/* eslint-disable angular/di */
/* eslint-disable angular/di-unused */
/* eslint-disable no-redeclare */
(function(){
    angular.module('tmx-app').config(['$stateProvider', '$urlRouterProvider', '$logProvider','routesProvider',tmxRouter]);


    var state=function(_state,_hasCtrl,_isAbstract,_resolve){
        this.state=_state;
        this.hasCtrl=_hasCtrl;
        this.isAbstract=_isAbstract;
        this.resolve=_resolve;
    };


    var crudState=function(_state,_listResolve,_addResolve,_editResolve,_url,_differentAddEditViews){
        this.state=_state;
        this.addResolve=_addResolve;
        this.listResolve=_listResolve;
        this.editResolve=_editResolve;
        this.differentAddEditViews=_differentAddEditViews;    
        this.url=_url;
    };


//=========================================
//Asynch function to return multiple things in a resolve
//input are key function pairs
    function getAsynch($q,calls){
        var deferred=$q.defer();
        var counter=0;
        var result={};
        calls.forEach(
            function(call){
          //If call is a promise
                if(angular.isDefined(call.promise.then)){
                    call.promise.then(
                        function(resultOfCall){
                  /*result[call.key]=resultOfCall;*/
                            putIn(result,call.key,resultOfCall);
                            counter++;
                            if(counter===calls.length){
                                deferred.resolve(result);
                            }
                        }
                    );
                }
                else{//else if it is a regular valriable
                    putIn(result,call.key,call.promise);
                    counter++;
                    if(counter===calls.length){
                        deferred.resolve(result);
                    }
                }
            }
        );
        return deferred.promise;
    }
    function putIn(object,key,value){
        var keys=key.split(".");
        var temp=object;
        function putKeyRecur(aKey,index){
            if(!angular.isDefined(temp[aKey]))
                temp[aKey]={};
            if(index<keys.length-1)temp=temp[aKey];
            else temp[aKey]=value;
        }
        keys.forEach(putKeyRecur);
    }

//========Resolves=========


/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


    function geoTrackingResolve($q,UsersService,LocationService){
        var calls=[
            {
                key:"Locations",
                promise:LocationService.all()
            },
            {
                key:"users",
                promise:UsersService.getUserByBranch(undefined)
            }
        ];
        return getAsynch($q,calls);
    }

///////////////////////////////////////Day End Management Resolve//////////////////////////////////////////////////////////////////////////////////
    function dayendListResolve($q,DayendService){
        var calls=[
            {
                key:"allActiveProcesses",
                promise:DayendService.GetAllActiveProcesses()
            },
            {
                key: "getDayendHistory",
                promise:DayendService.GetDayendHistory()
            }
        ];
  // var calls=[
  //   {
  //     key:"Devices",
  //     promise:DeviceService.GetActiveUnassignedDeviceLov()
  //   }
  // ];
        return getAsynch($q,calls);
    }


/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    function deviceListResolve($q,UserService){
        var calls=[
            {
                key:"Users",
                promise:UserService.ActiveLov()
            }
        ];
        return getAsynch($q,calls);
    //return "this should be company list";
    }

//*************Device Management Resolves******************
    function deviceAddResolve($q,DeviceService,lookupService,UserService){
        var calls=[
            {
                key:"Device",
                promise:new DeviceService()
            },
            {
                key: "Users",
                promise: UserService.ActiveLov()
            }/*,
       {
       key:"commonLookups",
       promise:lookupService.getLookups()
       }*/
        ];
        return getAsynch($q,calls);
    }

    function deviceEditResolve($stateParams,$q,DeviceService,lookupService,UserService){
        var calls=[
            {
                key:"Device",
                promise:DeviceService.getById($stateParams.Id)
            },
            {
                key: "Users",
                promise: UserService.ActiveLov()
            }/*,
       {
       key:"commonLookups",
       promise:lookupService.getLookups()
       }*/
        ];
        return getAsynch($q,calls);
    }
//***********PJP*****************************
    function pjpListResolve($q,LocationService){
        var calls=[
            {
                key:"Locations",
                promise:LocationService.lov()
            }
        ];
        return getAsynch($q,calls);
    }

    function pjpSummaryResolve($q,UsersService,PjpSummaryService) {
        var calls=[           
            {
                key: "Users",
                promise: UsersService.ActiveLov()
            },
            {
                key:"PJPList",
                promise:PjpSummaryService.getByAction("PJPLov",true)
            },
        ];
        return getAsynch($q, calls);
    }

    function pjpAddResolve($q,PjpService,LocationService,GeofenceService,UsersService){
        var calls=[
            {
                key:"Pjp",
                promise:new PjpService()
            },
            {
                key: "Locations",
                promise: LocationService.all()
            },
            {
                key: "Geofences",
                promise: GeofenceService.getByAction("GetGeofenceList",true)
            },
            {
                key: "Users",
                promise: UsersService.ActiveLov()
            },
            //{
            //     key:"Designations",
            //     promise:UsersService.DesignationsLov()
            // }
      
        ];
        return getAsynch($q,calls);
    }

  // {
  //   key: "PjpTypes",
  //   promise: lookupService.getPJPType()
  // }


    function pjpEditResolve($stateParams,$q,PjpService,LocationService,GeofenceService,UsersService){
        var calls=[
            {
                key: "Pjp",
                promise: PjpService.getById($stateParams.Id)
            },
            {
                key: "Locations",
                promise: LocationService.all()
            },
            {
                key: "Geofences",
                promise: GeofenceService.getByAction("GetGeofenceList",true)
            },
            {
                key: "Users",
                promise: UsersService.ActiveLov()
            },
            // {
            //     key: "Designations",
            //     promise: UsersService.DesignationsLov()
            // }
        ];
        return getAsynch($q,calls);
    }


  // ,
  //     {
  //       key: "PjpTypes",
  //       promise: lookupService.getPJPType()
  //     }


//***********Company Branches Resolves************
    function organizationsListResolve($q,OrganizationsService,LocationService){
        var calls=[{
            key:"Locations",
            promise:LocationService.all()
        }
  //{
  //  key:"Managers",
  //  promise:UsersService.BMLov()
  //}
        ];
        return getAsynch($q,calls);
//return "this should be company list";
    }


    function organizationsAddResolve($stateParams,$q,CustomersService,lookupService,LocationService,TMX_FINANCE_CONSTANTS,CompanyService){
        var calls=[
            {
                key:"activeLocations",
                promise:LocationService.getActiveLocations()
            },
            {
                key: "OrganizationStatus",
                promise:lookupService.getLocalLookupsByType(TMX_FINANCE_CONSTANTS.LOOKUP_TYPES.SA_EMPLOYER_STATUS)
            },
            {
                key: "OrganizationIndustry",
                promise:lookupService.getLocalLookupsByType(TMX_FINANCE_CONSTANTS.LOOKUP_TYPES.INDUSTRY_TYPE)
            },
            {
                key: "OrganizationType",
                promise:lookupService.getLocalLookupsByType(TMX_FINANCE_CONSTANTS.LOOKUP_TYPES.ORGANIZATION_TYPE)
            },
            {
                key: "OrganizationRelations",
                promise:lookupService.getLocalLookupsByType(TMX_FINANCE_CONSTANTS.LOOKUP_TYPES.ORGANIZATION_RELATION)
            },
            {
                key:"Company",
                promise:CompanyService.getLovs()
            },
            {
                key:"activeCustomers",
                promise:CustomersService.getActiveCustomers()
            }

        ];
        return getAsynch($q,calls);
    }

    function organizationsEditResolve($stateParams,$q,OrganizationsService,lookupService,LocationService,CustomersService,TMX_FINANCE_CONSTANTS,CompanyService){
        var calls = [
            {
                key: "Organization",
                promise: OrganizationsService.getById($stateParams.Id)
            },
            {
                key: "OrganizationStatus",
                promise:lookupService.getLocalLookupsByType(TMX_FINANCE_CONSTANTS.LOOKUP_TYPES.SA_EMPLOYER_STATUS)
            },
            {
                key: "OrganizationIndustry",
                promise:lookupService.getLocalLookupsByType(TMX_FINANCE_CONSTANTS.LOOKUP_TYPES.INDUSTRY_TYPE)
            },
            {
                key: "OrganizationType",
                promise:lookupService.getLocalLookupsByType(TMX_FINANCE_CONSTANTS.LOOKUP_TYPES.ORGANIZATION_TYPE)
            },
            {
                key: "OrganizationRelations",
                promise:lookupService.getLocalLookupsByType(TMX_FINANCE_CONSTANTS.LOOKUP_TYPES.ORGANIZATION_RELATION)
            },
            {
                key:"activeLocations",
                promise:LocationService.getActiveLocations()
            },
            {
                key:"Company",
                promise:CompanyService.getLovs()
            },
            {
                key:"activeCustomers",
                promise:CustomersService.getActiveCustomers()
            }
        ];
        return getAsynch($q,calls);
    }

    function branchListResolve($q,CompanyService,LocationService){
        var calls=[
            {
                key:"Companies",
                promise:CompanyService.lov()
            },
            {
                key:"Locations",
                promise:LocationService.all()
            }
      //{
      //  key:"Managers",
      //  promise:UsersService.BMLov()
      //}
        ];
        return getAsynch($q,calls);
    //return "this should be company list";
    }


    function branchAddResolve($q,BranchService,LocationService,CompanyService,LoanProductService,RoleManagementService,lookupService,TMX_FINANCE_CONSTANTS){
        var calls=[
            {
                key:"Branch",
                promise:new BranchService()
            },
            {
                key: "Companies",
                promise: CompanyService.lov()
            },
            {
                key:"Locations",
                promise:LocationService.all()
            },
            {
                key:"allActiveProducts",
                promise:LoanProductService.getActiveProducts()
            },
            {
                key:"RoleLov",
                promise:RoleManagementService.getByAction("Activelov",true)
            },
            {
                key: "commandTypeLkp",
                promise: lookupService.getLocalLookupsByType(TMX_FINANCE_CONSTANTS.LOOKUP_TYPES.COMMAND_APPLICATION_STATUS_MAPPING)
            }
      //{
      //  key:"Managers",
      //  promise:UsersService.BMLov()
      //}
        ];
        return getAsynch($q,calls);
    }

    function branchEditResolve($stateParams,$q,BranchService,LocationService,CompanyService,LoanProductService,UsersService,RequestService,TMX_FINANCE_CONSTANTS,RoleManagementService,lookupService){
        var calls=[
            {
                key:"Branch",
                promise:BranchService.getById($stateParams.Id)
            },
            {
                key: "Companies",
                promise: CompanyService.lov()
            },
            {
                key:"Locations",
                promise:LocationService.all()
            },
            {
                key:"allActiveProducts",
                promise:LoanProductService.getActiveProducts()
            },
            {
                key:"Requests",
                promise:RequestService.getRequestsByEntity(TMX_FINANCE_CONSTANTS.REQUEST_TYPES.BranchRequest.LookupId,$stateParams.Id)
            },
            {
                key:"RoleLov",
                promise:RoleManagementService.getByAction("Activelov",true)
            },            
            {
                key: "commandTypeLkp",
                promise: lookupService.getLocalLookupsByType(TMX_FINANCE_CONSTANTS.LOOKUP_TYPES.COMMAND_APPLICATION_STATUS_MAPPING)
            }      
        ];
        return getAsynch($q,calls);
    }
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // eslint-disable-next-line no-unused-vars
    function companyListResolve($q,CompanyService){
        var calls=[
            {
                key:"Companies",
                promise:CompanyService.all()
            }
        ];
        return getAsynch($q,calls);
    //return "this should be company list";
    }

  /*
   function companyListResolve(CompanyService){
   return CompanyService.all();
   //return "this should be company list";
   }
   */
    function companyAddResolve($q,CompanyService){
        var calls=[
            {
                key:"Company",
                promise:new CompanyService()
            }/*,
       {
       key:"commonLookups",
       promise:lookupService.getLookups()
       }*/
        ];
        return getAsynch($q,calls);
    }

    function loanApplicationResolve($q,LoanProductService,BranchService,lookupService,TMX_FINANCE_CONSTANTS){
        var calls=[
            {
                key:"loanProducts",
                promise:LoanProductService.getAllLoanProducts()
            },
            {
                key: "userBranches",
                promise: BranchService.getUserBranch()
            },
            {
                key: "productTypesLkp",
                promise: lookupService.getLocalLookupsByType(TMX_FINANCE_CONSTANTS.LOOKUP_TYPES.Product)
            }
        ];
        return getAsynch($q,calls);
    }

    function accountOpeningApplicationResolve($q,LoanProductService,lookupService,BranchService,TMX_FINANCE_CONSTANTS){
        var calls=[
            {
                key:"loanProducts",
                promise:LoanProductService.getAllLoanProducts()
            },
            {
                key:"commonLookups",
                promise:lookupService.getLookups()
            },
            {
                key:"LoanStatus",
                promise:lookupService.getLoanApplicationStatusLkp()
            },
            {
                key: "userBranches",
                promise: BranchService.getUserBranch()
            },
            {
                key: "productTypesLkp",
                promise: lookupService.getLocalLookupsByType(TMX_FINANCE_CONSTANTS.LOOKUP_TYPES.Product)
            }
      // {
      //     key:"LoanProductLov",
      //     promise:LoanProductService.getByAction("lov",true)
      // },
      // {
      //     key:"LoanProductTenureLov",
      //     promise:LoanProductService.getByAction("ProductTenureLov",true)
      // }

        ];
        return getAsynch($q,calls);
    }
    function tradeRepositoryResolve($q,LoanProductService,lookupService,TMX_FINANCE_CONSTANTS,BranchService){
        var calls=[
            {
                key:"loanProducts",
                promise:LoanProductService.getAllLoanProducts()
            },
            {
                key:"commonLookups",
                promise:lookupService.getLookups()
            },
            {
                key:"LoanStatus",
                promise:lookupService.getLoanApplicationStatusLkp()
            },
            {
                key: "productTypesLkp",
                promise: lookupService.getLocalLookupsByType(TMX_FINANCE_CONSTANTS.LOOKUP_TYPES.Product)
            },
            {
                key: "userBranches",
                promise: BranchService.getUserBranch()
            }
        ];
        return getAsynch($q,calls);
    }

    // eslint-disable-next-line no-unused-vars
    function loanApplicationAddResolve($q,LoanApplicationService){
        var calls=[
            {
                key:"loanApplication.data",
                promise:new LoanApplicationService()
            }/*,
       {
       key:"commonLookups",
       promise:lookupService.getLookups()
       }*/
        ];
        return getAsynch($q,calls);
    }

  // ,
      // {
      //   key:"History",
      //   promise:LoanApplicationService.getByAction('GetBPMProcessHistory/'+$stateParams.Id,true)
      //  },
       /*,
       {
       key:"commonLookups",
       promise:lookupService.getLookups()
       }*/

    // eslint-disable-next-line no-unused-vars
    function loanApplicationEditResolve($stateParams,$q,LoanApplicationService){
        var calls=[
            {
                key:"loanApplication",
                promise:LoanApplicationService.getApplicationById($stateParams.Id)
            }
        ];
        return getAsynch($q,calls);
    }
    function companyEditResolve($stateParams,$q,CompanyService){
        var calls=[
            {
                key:"Company",
                promise:CompanyService.getById($stateParams.Id)
            }/*,
       {
       key:"commonLookups",
       promise:lookupService.getLookups()
       }*/
        ];
        return getAsynch($q,calls);
    }

    function currencyEditResolve($stateParams,$q,CurrencyService){
        var calls=[
            {
                key:"Currency",
                promise:CurrencyService.getById($stateParams.Id)
            }
        ];
        return getAsynch($q,calls);
    }

  
    function geoFenceListResolve($q,LocationService){
        var calls=[
            {
                key:"Locations",
                promise:LocationService.lov()
            }
        ];
        return getAsynch($q,calls);
    }
    function geoFenceAddResolve($q,GeofenceService,LocationService){
        var calls=[
            {
                key:"GeoFence",
                promise: new GeofenceService()
            },
            {
                key:"Locations",
                promise:LocationService.all()
            }
        ];
        return getAsynch($q,calls);
    }
    function geoFenceEditResolve($stateParams,$q,GeofenceService,LocationService){
        var calls=[
            {
                key:"GeoFence",
                promise:GeofenceService.getByAction('GetByLocationId/' + $stateParams.Id, true, 'get')
                
            },
            {
                key:"Locations",
                promise:LocationService.all()
            }
        ];
        return getAsynch($q,calls);
    }

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    function usersListResolve($q,UsersService,DeviceService){
        var calls=[
            {
                key:"Devices",
                promise:DeviceService.GetActiveUnassignedDeviceLov()
            }
        ];
        return getAsynch($q,calls);
    }
    function usersAddResolve($q,UsersService,LocationService,DeviceService){
        var calls=[
            {
                key:"User",
                promise:(new UsersService())
            },
            {
                key:"Users",
                promise:UsersService.ActiveLov()
            },
            {
                key:"locations",
                promise:LocationService.getActiveLocations()
            },
            {
                key:"Devices",
                promise:DeviceService.GetActiveUnassignedDeviceLov()
            }
        ];
        return getAsynch($q,calls);
    }

  //function usersEditResolve($stateParams,$q,UsersService,LocationService,DeviceService,lookupService){
  //  var calls=[
  //    {
  //      key:"User",
  //      promise:UsersService.getById($stateParams.Id)
  //    },
  //    {
  //      key:"Users",//for list of reporting bosses
  //      promise:UsersService.ActiveLov()
  //    },
  //    {
  //      key:"Designations",
  //      promise:UsersService.DesignationsLov()
  //    },
  //    {
  //      key:"locations",
  //      promise:LocationService.all()
  //    },
  //    {
  //      key:"Devices",
  //      promise:DeviceService.GetActiveUnassignedDeviceLov($stateParams.Id)
  //    }
  //  ];
  //  return getAsynch($q,calls);
  //}

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    function processInstancesListResolve($q,ProcessInstancesService){
        var calls=[
            {
                key:"Customer",
                promise:(new ProcessInstancesService())
            }
        ];
        return getAsynch($q,calls);
    }
    function processInstancesAddResolve($q,ProcessInstancesService){
        var calls=[
            {
                key:"Customer",
                promise:(new ProcessInstancesService())
            }
        ];
        return getAsynch($q,calls);
    }
    function processInstancesEditResolve($stateParams,$q,ProcessInstancesService){
        var calls=[
            {
                key:"Customer",
                promise:ProcessInstancesService.getById($stateParams.Id)
            }
        ];
        return getAsynch($q,calls);
    }

    function requstesEditResolve($q,$stateParams,RequestService) {
        var calls=[
            {
                key:"RequestsData",
                promise:RequestService.getById($stateParams.Id)
            }
        ];
        return getAsynch($q,calls);
    }
    function leadsEditResolve($q,$stateParams,LeadService,lookupService,TMX_FINANCE_CONSTANTS) {
        var calls=[
            {
                key:"LeadData",
                promise:LeadService.getById($stateParams.Id)
            },
            {
                key: "LeadGeneratorLookup",
                promise: lookupService.getLocalLookupsByType(TMX_FINANCE_CONSTANTS.LOOKUP_TYPES.LEAD_GENERATOR)
            },
            {
                key: "LeadTypeLookup",
                promise: lookupService.getLocalLookupsByType(TMX_FINANCE_CONSTANTS.LOOKUP_TYPES.LEAD_TYPE)
            },
        ];
        return getAsynch($q,calls);
    }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    function customersListResolve($q,CustomersService){
        var calls=[
            {
                key:"Customer",
                promise:(new CustomersService())
            }
        ];
        return getAsynch($q,calls);
    }
    function customersAddResolve($q,CustomersService,OrganizationsService,lookupService,TMX_FINANCE_CONSTANTS){
        var calls=[
            {
                key:"Customer",
                promise:(new CustomersService())
            },
            {
                key:"Organizations",
                promise:OrganizationsService.getAllOrganizations()
            },
            {
                key: "OrganizationRelations",
                promise:lookupService.getLocalLookupsByType(TMX_FINANCE_CONSTANTS.LOOKUP_TYPES.ORGANIZATION_RELATION)
            }
        ];
        return getAsynch($q,calls);
    }

    function customersEditResolve($stateParams,$q,CustomersService,OrganizationsService,lookupService,TMX_FINANCE_CONSTANTS){        
        var calls=[
            {
                key:"Customer",
                promise:CustomersService.getById($stateParams.Id)
            },
            {
                key:"Organizations",
                promise:OrganizationsService.getAllOrganizations()
            },
            {
                key: "OrganizationRelations",
                promise:lookupService.getLocalLookupsByType(TMX_FINANCE_CONSTANTS.LOOKUP_TYPES.ORGANIZATION_RELATION)
            }
        ];
        return getAsynch($q,calls);
    }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    function profileLinkListResolve(CurrentUserService,$q,UsersService){
        var calls=[
            {
                key:"User",
                promise:UsersService.getById(CurrentUserService.getUserObject().Id)
            },
      //{
      //  key:"Users",
      //  promise:UsersService.ActiveLov()
      //},
      //{
      //  key:"Designations",
      //  promise:UsersService.DesignationsLov()
      //},
      //{
      //      key:"locations",
      //      promise:LocationService.getByAction('Active',true)
      //},
      //{
      //  key:"locations",
      //  promise:LocationService.lov()
      //},
      //{
      //  key:"Devices",
      //  promise:DeviceService.GetActiveUnassignedDeviceLov()
      //}
        ];
        return getAsynch($q,calls);
    }

    function profileLinkEditResolve($stateParams,$q,UsersService,LocationService,DeviceService,lookupService){
        var calls=[
            {
                key:"User",
                promise:UsersService.getById($stateParams.Id)
            },
      //{
      //  key:"Users",
      //  promise:UsersService.ActiveLov()
      //},
            {
                key:"locations",
                promise:LocationService.getActiveLocations()
            },
      //{
      //  key:"locations",
      //  promise:LocationService.lov()
      //},
            {
                key:"Devices",
                promise:DeviceService.lov()
            },
            {
                key:"UserTypes",
                promise:lookupService.getUserTypes()
            }
        ];
        return getAsynch($q,calls);
    }
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    function usersListResolve($q,UsersService,DeviceService){
        var calls=[
            {
                key:"Devices",
                promise:DeviceService.GetActiveUnassignedDeviceLov()
            }
        ];
        return getAsynch($q,calls);
    }
    function usersAddResolve($q,UsersService,LocationService,DeviceService,lookupService,CompanyService,RoleManagementService){
        var calls=[
            {
                key:"User",
                promise:(new UsersService())
            },
            {
                key:"Users",
                promise:UsersService.ActiveLov()
            },
            {
                key:"locations",
                promise:LocationService.all()
            },
            {
                key:"Devices",
                promise:DeviceService.GetActiveUnassignedDeviceLov()
            },
            {
                key:"Company",
                promise:CompanyService.getLovs()
            },
            {
                key:"RoleLov",
                promise:RoleManagementService.getByAction("Activelov",true)
            }
        ];
        return getAsynch($q,calls);
    }

    function usersEditResolve($stateParams,$q,UsersService,LocationService,DeviceService,RoleManagementService,RequestService,CompanyService,TMX_FINANCE_CONSTANTS){
        var calls=[
            {
                key:"User",
                promise:UsersService.getById($stateParams.Id)
            },
            {
                key:"AuthUser",
                promise: UsersService.getUserFromAuth($stateParams.Id)
            },
            {
                key:"Users",
                promise:UsersService.ActiveLov()
            },
            {
                key:"locations",
                promise:LocationService.getActiveLocations()
            },
            {
                key:"Devices",
                promise:DeviceService.GetActiveUnassignedDeviceLov($stateParams.Id)
            },
            {
                key:"RoleLov",
                promise:RoleManagementService.getByAction("Activelov",true)
            },
            {
                key:"Requests",
                promise:RequestService.getRequestsByEntity(TMX_FINANCE_CONSTANTS.REQUEST_TYPES.UserRequest.LookupId,$stateParams.Id)
            },      
            {
                key:"Company",
                promise:CompanyService.getLovs()
            }
        ];
        return getAsynch($q,calls);
    }
 
 
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    function usersDynamicListResolve($q,UsersDynamicService,DeviceService){
        var calls=[
            {
                key:"Devices",
                promise:DeviceService.GetActiveUnassignedDeviceLov()
            }
        ];
        return getAsynch($q,calls);
    }
    function usersDynamicAddResolve($q,UsersDynamicService,LocationService,DeviceService){
        var calls=[
            {
                key:"User",
                promise:(new UsersDynamicService())
            },
            {
                key:"Users",
                promise:UsersDynamicService.lov()
            },
            {
                key:"locations",
                promise:LocationService.all()
            },
            {
                key:"Devices",
                promise:DeviceService.GetActiveUnassignedDeviceLov()
            },
            {
                key:"testingNoPromise",
                promise:{ field1 : "field1"}
            }
        ];
        return getAsynch($q,calls);
    }

    function usersDynamicEditResolve($stateParams,$q,UsersDynamicService,LocationService,DeviceService){
        var calls=[
            {
                key:"User",
                promise:UsersDynamicService.getById($stateParams.Id)
            },
            {
                key:"Users",
                promise:UsersDynamicService.lov()
            },
            {
                key:"Designations",
                promise:UsersDynamicService.DesignationsLov()
            },
            {
                key:"locations",
                promise:LocationService.all()
            },
            {
                key:"Devices",
                promise:DeviceService.GetActiveUnassignedDeviceLov()
            }
        ];
        return getAsynch($q,calls);
    }
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////PRICE LIST//////////////////////////////
    function priceListListResolve(PriceListService){
        return PriceListService.all();
    //return "this should be company list";
    }

    function priceListAddResolve(PriceListService){
        return (new PriceListService());
    }

    function priceListEditResolve($stateParams,PriceListService){
        return PriceListService.getById($stateParams.Id);
    }
//////////////////////PRICE LIST/////////////////////////////////////////////////////////////////////////////////////////
// ////////////////////LOAN PRODUCT/////////////////////////////////////////////////////////////////////////////////////
    function loanProductListResolve(LoanProductService){
     
    //LoanProductService.getAllLoanProducts().then(function(data){
    //},function(data){
    //});
        return LoanProductService.getAllLoanProducts();
    }
    function loanProductAddResolve($q, LoanProductService){

        var calls=[
            {
                key:"LoanProduct",
                promise: (new LoanProductService())
            }
        ];

        return getAsynch($q,calls);
    }

    function loanProductEditResolve($stateParams,$q,LoanProductService){
        var calls=[
            {
                key:"LoanProduct",
                promise:LoanProductService.getById($stateParams.Id)
            }
        ];
        return getAsynch($q,calls);

    }
///////////////////////////////////////LOAN PRODUCT////////////////////////////////////////////////////////////////////
// ////////////////////ROLE MANAGEMENT//////////////////////////////
//  function roleManagementListResolve(RoleManagementService){
//     
//    //RoleManagementService.getAllRoles().then(function(data){
//    //},function(data){
//    //});
//    return RoleManagementService.getAllRoles();
// }

    function roleManagementAddResolve($q, RoleManagementService){
    //return (new RoleManagementService());
        var calls=[
            {
                key:"Role",
                promise: (new RoleManagementService())
            },
            {
                key:"Privileges",
                promise:RoleManagementService.getAllPrivileges()
            },
            {
                key:"Entities",
                promise:RoleManagementService.getEntity()
            }
        ];

        return getAsynch($q,calls);
    }

    function roleManagementEditResolve($stateParams,$q,RoleManagementService,RequestService,TMX_FINANCE_CONSTANTS){
        var calls=[
            {
                key:"Role",
                promise:RoleManagementService.getById($stateParams.Id)
            },
            {
                key:"Privileges",
                promise:RoleManagementService.getAllPrivileges()
            },
            {
                key:"Entities",
                promise:RoleManagementService.getEntity()
            },
            {
                key:"Requests",
                promise:RequestService.getRequestsByEntity(TMX_FINANCE_CONSTANTS.REQUEST_TYPES.RoleRequest.LookupId,$stateParams.Id)
            }

        ];
        return getAsynch($q,calls);
    // return RoleManagementService.getById($stateParams.Id);
    }
//////////////////////ROLE MANAGEMENT//////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    function distributorListResolve(DistributorService){
        return DistributorService.all();
    //return "this should be company list";
    }

    function distributorAddResolve(DistributorService){
        return (new DistributorService());
    }

    function distributorEditResolve($stateParams,DistributorService){
        return DistributorService.getById($stateParams.Id);
    }
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // function locationListResolve(LocationService){
  //   return LocationService.all();
  //   //return "this should be company list";
  // }

    function locationAddResolve(LocationService,$q){
        var calls=[
            {
                key:"location.data",
                promise:new LocationService()
            },
            {
                key:"locations",
                promise:LocationService.all()
            }
        ];
        return getAsynch($q,calls);
    }

    function locationEditResolve($stateParams,LocationService,$q){
        var calls=[
            {
                key:"location",
                promise:LocationService.getById($stateParams.Id)
            },
            {
                key:"locations",
                promise:LocationService.all()
            }
        ];
        return getAsynch($q,calls);
    }
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    function productListResolve(ProductService){
        return ProductService.all();
    //return "this should be company list";
    }

    function productAddResolve(ProductService){
        return (new ProductService());
    }

    function productEditResolve($stateParams,ProductService){
        return ProductService.getById($stateParams.Id);
    }
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//  function userListResolve(UserService){
//    return UserService.all();
//    //return "this should be company list";
//  }

  //function userAddResolve(UserService){
  //  return (new UserService());
  //}

  //function userEditResolve($stateParams,UserService){
  //  return UserService.getById($stateParams.Id);
  //}
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    function supplierListResolve(SupplierService){
        return SupplierService.all();
    //return "this should be company list";
    }

    function supplierAddResolve(SupplierService){
        return (new SupplierService());
    }

    function supplierEditResolve($stateParams,SupplierService){
        return SupplierService.getById($stateParams.Id);
    }
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    function warehouseListResolve(WarehouseService){
        return WarehouseService.all();
    //return "this should be company list";
    }

    function warehouseAddResolve(WarehouseService){
        return (new WarehouseService());
    }

    function warehouseEditResolve($stateParams,WarehouseService){
        return WarehouseService.getById($stateParams.Id);
    }
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    function uploadDataResolve($stateParams,$injector){
        if(!angular.isDefined($stateParams.Id) || $stateParams.Id.length<=0)return undefined;
        var service=$stateParams.Id+"Service";
        var UploadDataService= $injector.get(service);
        return UploadDataService;
    }
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


    function userLimitListResolve($q){
        // var calls=[
        // ]
        // return getAsynch($q,calls);
    //return "this should be company list";
    }
    function userLimitEditResolve($stateParams,$q,TMX_FINANCE_CONSTANTS,LoanProductService,UserLimitManagementService,lookupService,RoleManagementService,CompanyService,UsersService){
        //TODO
        var calls =[
            {  
                key: "LoanLimit",
                promise: UserLimitManagementService.getLimitById($stateParams.Id)
            },
            {
                key:"UsersList",
                promise:UsersService.all()
            },
            {
                key:"RoleLov",
                promise:RoleManagementService.getByAction("Activelov",true)
            },
            {
                key:"Company",
                promise:CompanyService.getLovs()
            },
            {
                key: "UserTypes",
                promise:lookupService.getLocalLookupsByType(TMX_FINANCE_CONSTANTS.LOOKUP_TYPES.USER)
            },
            {
                key:"ActiveProducts",
                promise:LoanProductService.getActiveProducts()
            }
        ]
        return getAsynch($q, calls);
    }

    function userLimitAddResolve($stateParams,$q,TMX_FINANCE_CONSTANTS,LoanProductService,UserLimitManagementService,lookupService,RoleManagementService,CompanyService,UsersService){
        //TODO
        var calls =[
            {  
                key: "LoanLimit",
                promise: new UserLimitManagementService()
            },
            {
                key:"UsersList",
                promise:UsersService.all()
            },
            {
                key:"RoleLov",
                promise:RoleManagementService.getByAction("Activelov",true)
            },
            {
                key:"Company",
                promise:CompanyService.getLovs()
            },
            {
                key: "UserTypes",
                promise:lookupService.getLocalLookupsByType(TMX_FINANCE_CONSTANTS.LOOKUP_TYPES.USER)
            },
            {
                key:"ActiveProducts",
                promise:LoanProductService.getActiveProducts()
            }
        ]
        return getAsynch($q, calls);
    }
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    function lookupListResolve(LookupService,$q){
        // var calls=[
        // ]
        // return getAsynch($q,calls);
    //return "this should be company list";
    }


    function lookupEditResolve($stateParams,$q,LookupManagementService,lookupService){
        //TODO
        var calls =[
            {  
                key: "Lookups",
                promise: LookupManagementService.getLookupByType($stateParams.Id)
            },
            {
                key: "AllGroupedLookups", 
                promise: lookupService.getLookups()
            },
            {
                key: "AllLookups",
                promise: lookupService.getAllLookups()
            },
            {
                key: "Locales",
                promise: lookupService.getAllLocales()
            }
        ]
        return getAsynch($q, calls);
    }
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    function DynamicFormAddResolve($q,TenantFieldSetupService,lookupService,$stateParams,LoanApplicationService,LoanProductService){
        var loanApp= new LoanApplicationService();
        loanApp.LoanProductId=$stateParams.Id;
        var calls=[

            {
                key:"LoanProductId",
                promise:$stateParams.Id
            },
            {
                key:"loanProducts",
                promise:LoanProductService.getAllLoanProducts()
            }
      // ,
      // {
      //   key:"lookups",
      //   promise:lookupService.getLookupByType('IdentificationDocumentTypes')
      // },

      // {
      //   key:"pageSchema",
      //   promise:TenantFieldSetupService.getScreenByProductId($stateParams.Id)
      // },
      // {
      //   key:"lookups",
      //   promise:lookupService.getLookups()
      // },
      // {
      //   key:"loanApplicationData.data",
      //   promise:loanApp
      // },
      // {
      //   key:"informationIconData",
      //   promise:LoanApplicationService.getByAction("informationicon",false)
      // },
      // {
      //   key:"questions.TmxLoanApplicationPSCValuation",
      //   promise:LoanApplicationService.getByAction("GetAllPSCQuestionAnswers",true)
      // },
      // {
      //   key:"questions.TmxCreditScoreValuation",
      //   promise:LoanApplicationService.getByAction("GetAllCreditScoreQuestionAnswers",true)
      // },
      // {
      //   key:"loanProduct",
      //   promise:LoanProductService.getById($stateParams.Id)
      //   //promise:
      // }
        ];
        return getAsynch($q,calls);
    }
    // {
      //  key:"History",
      //  promise:LoanApplicationService.getByAction('GetBPMProcessHistory/'+$stateParams.Id,true)
      // },
      
        
      // {
      //   key:"questions.TmxLoanApplicationPSCValuation",
      //   promise:LoanApplicationService.getByAction("GetAllPSCQuestionAnswers",true)
      // },
      // {
      //   key:"questions.TmxCreditScoreValuation",
      //   promise:LoanApplicationService.getByAction("GetAllCreditScoreQuestionAnswers",true)
      // }

    function DynamicFormResolve($q,TenantFieldSetupService,lookupService,$stateParams,tmxResource,UsersService,LoanApplicationService,PrivateService,LocationService){
        var calls=[
            {
                key:"responseData",
                promise:TenantFieldSetupService.getScreensByLoanAppId($stateParams.Id, $stateParams.readonly=='true',$stateParams.joint ? parseInt($stateParams.joint) : 1)
            },
            {
                key:"TabPrivileges",
                promise:LoanApplicationService.getTabEntityMapping()
            },
            {
                key:"Configurations",
                promise:PrivateService.GetUserCompanyConfigurations()
            },
            {
                key:"Locations",
                promise:LocationService.getActiveLocations()
            },
        ];
        return getAsynch($q,calls);
    }

    function DynamicFormAccountResolve($q,TenantFieldSetupService,lookupService,$stateParams,tmxResource,UsersService,LoanApplicationService){
        var calls=[
            {
                key:"responseData",
                promise:TenantFieldSetupService.getScreensByAccountAppId($stateParams.Id, $stateParams.readonly=='true',$stateParams.joint ? parseInt($stateParams.joint) : 1)
            }
            ,
            {
                key:"lookups",
                promise:lookupService.getLookups()
            }
            ,
            {
                key:"TabPrivileges",
                promise:LoanApplicationService.getTabEntityMapping()
            }

        ];
        return getAsynch($q,calls);
    }
    function DynamicFormTradeResolve($q,TenantFieldSetupService,lookupService,$stateParams, $state,tmxResource,UsersService,LoanApplicationService){
        
        var calls=[
            {
                key:"responseData",
                promise: $stateParams.Id != -1 ?
                TenantFieldSetupService.getScreensByTradeAppId($stateParams.Id, $stateParams.readonly=='true',$stateParams.joint ? parseInt($stateParams.joint) : 1) :
                TenantFieldSetupService.getScreensByTradeProductId($state.params.ProductId, $stateParams.readonly=='true',$stateParams.joint ? parseInt($stateParams.joint) : 1, $state.params.AppData)
            }
            ,
            {
                key:"lookups",
                promise:lookupService.getLookups()
            }
            ,
            {
                key:"TabPrivileges",
                promise:LoanApplicationService.getTabEntityMapping()
            }

        ];
        return getAsynch($q,calls);
    }
  // {
  //   key: "user",
  //   promise: UsersService.getUserByUserName($stateParams.user)
  // }
    function inboxResolve($q){
        var calls=[
      // {
      //   key:"loanProducts",
      //   promise:LoanProductService.getAllLoanProducts()
      // },
      // {
      //   key:"commonLookups",
      //   promise:lookupService.getLookups()
      // },
      // {
      //   key:"LoanStatus",
      //   promise:lookupService.getLoanStatusLkp()
      // }
        ];
        return getAsynch($q,calls);
    }
    function ruleResolve($q,LoanProductService,lookupService){
        var calls=[
            {
                key:"loanProducts",
                promise:LoanProductService.getAllActiveProducts()
            },
            {
                key:"commonLookups",
                promise:lookupService.getLookups()
            }
      // {
      //   key:"LoanStatus",
      //   promise:lookupService.getLoanStatusLkp()
      // }
        ];
        return getAsynch($q,calls);
    }


    // eslint-disable-next-line no-unused-vars
    function dashboardResolve($q){
        var calls=[
      // {
      //   key:"loanProducts",
      //   promise:LoanProductService.getAllLoanProducts()
      // },
      // {
      //   key:"commonLookups",
      //   promise:lookupService.getLookups()
      // },
      // {
      //   key:"LoanStatus",
      //   promise:lookupService.getLoanStatusLkp()
      // }
        ];
        return getAsynch($q,calls);
    }
    function bulkReassignmentListResolve($q,LoanProductService,BranchService) {
        var calls=[
            {
                key:"loanProducts",
                promise:LoanProductService.getAllLoanProducts()
            },
            {
                key:"branches",
                promise:BranchService.getByAction('', true, 'get')
            },
        ];
        return getAsynch($q,calls);
    }
    function bulkUploadListResolve($q,lookupService,LoanProductService,BulkUploadService,TMX_FINANCE_CONSTANTS) {
        var calls=[
            {
                key:"bukUploadTypes",
                promise:lookupService.getLocalLookupsByType(TMX_FINANCE_CONSTANTS.LOOKUP_TYPES.BULK_UPLOAD_TYPES)
            },
            {
                key:"Organizations",
                promise:BulkUploadService.getOrganizations()
            },
            {
                key:"Products",
                promise:LoanProductService.getAllActiveProducts()
            }
        ];
        return getAsynch($q,calls);
    }
  
    function inboxResolve($q,LoanProductService){
        var calls=[
            {
                key:"loanProducts",
                promise:LoanProductService.getAllLoanProducts()
            },
      // {
      //   key:"commonLookups",
      //   promise:lookupService.getLookups()
      // },
      // {
      //   key:"LoanStatus",
      //   promise:lookupService.getLoanStatusLkp()
      // }
        ];
        return getAsynch($q,calls);
    }
    function callingReportResolve($q,RoleManagementService){
        var calls=[
            {
                key:"RoleLov",
                promise:RoleManagementService.getByAction("Activelov",true)
            },
      // {
      //   key:"commonLookups",
      //   promise:lookupService.getLookups()
      // },
      // {
      //   key:"LoanStatus",
      //   promise:lookupService.getLoanStatusLkp()
      // }
        ];
        return getAsynch($q,calls);
    }
    // eslint-disable-next-line no-unused-vars
    function generalReportResolve($q){
        var calls=[

        ];
        return getAsynch($q,calls);
    }

    // eslint-disable-next-line no-unused-vars
    function requestListResolve($q,RequestService){
        var calls=[
      
        ];
        return getAsynch($q,calls);
    }

  // var loanApp= new LoanApplicationService();
  // ,
  //     {
  //       key:"loanApplicationData.data",
  //       promise:loanApp
  //     }
    function dummyDynamicFormResolve($q,TenantFieldSetupService){
    

        var calls=[
            {
                key:"pageSchema",
                promise:TenantFieldSetupService.getByScreenId(37)
            },
      // {
      //   key:"lookups",
      //   promise:lookupService.getLookups()
      // }
      
        ];
        return getAsynch($q,calls);
    }
    function businessReportsResolve($q, RoleManagementService, lookupService, BranchService, TMX_FINANCE_CONSTANTS,LocationService,LoanProductService) {
        var calls = [
            {
                key: "Roles",
                promise: RoleManagementService.getAllRoles()
            },
            {
                key: "ReportTypes",
                promise: lookupService.getLocalLookupsByType(TMX_FINANCE_CONSTANTS.LOOKUP_TYPES.REPORT_TYPE)
            },
            {
                key: "Branches",
                promise: BranchService.getBranchesByUserCompany()
            },
            {
                key: "Locations",
                promise: LocationService.getActiveLocations()
            },
            {
                key: "Products",
                promise: LoanProductService.getActiveProducts()
            }
        ];
        return getAsynch($q, calls);
    }
    function sessionHistoryReportResolve($q, RoleManagementService) {
        var calls = [
            {
                key: "Roles",
                promise: RoleManagementService.getAllRoles()
            }
        ];
        return getAsynch($q, calls);
    }

    function branchLevelReportResolve($q,LoanApplicationService){
        var calls=[
            {
                key:"TimeFrames",
                promise:LoanApplicationService.getTimeFrames()
            }
        ];
        return getAsynch($q,calls);
    }
    function areaLevelReportResolve($q,LoanApplicationService){
        var calls=[
            {
                key:"TimeFrames",
                promise:LoanApplicationService.getTimeFrames()
            }
        ];
        return getAsynch($q,calls);
    }
    function applicationStatusReportResolve($q,LoanProductService){
        var calls=[
            {
                key:"allActiveProducts",
                promise:LoanProductService.getActiveProducts()
            }
        ];
        return getAsynch($q,calls);
    }
    function SAReportsResolve($q,lookupService,TMX_FINANCE_CONSTANTS,OrganizationsService){
        var calls=[
            {
                key:"SAStatuses",
                promise:lookupService.getLocalLookupsByType(TMX_FINANCE_CONSTANTS.LOOKUP_TYPES.SA_APPLICATION_STATUS)
            },
            {
                key:"Organizations",
                promise:OrganizationsService.getAllOrganizations()
            }
        ];
        return getAsynch($q,calls);
    }
    function regionLevelReportResolve($q,LoanApplicationService){
        var calls=[
            {
                key:"TimeFrames",
                promise:LoanApplicationService.getTimeFrames()
            }
        ];
        return getAsynch($q,calls);
    }


    function privateResolve($q,lookupService,PrivateService,RoleManagementService){
        var calls=[
            {
                key:"lookups",
                promise:lookupService.getLookups()
            },
            {
                key:"Configurations",
                promise:PrivateService.GetUserCompanyConfigurations()
            },
            {
                key:"UserPrivileges",
                promise:RoleManagementService.getLoggedInUserPrivileges()
            }
        ];
        return getAsynch($q,calls);
    }

    function loanRepaymentListResolve($q,LoanProductService,BranchService) {
        var calls=[
            {
                key:"loanProducts",
                promise:LoanProductService.getAllLoanProducts()
            },
            {
                key:"branches",
                promise:BranchService.getByAction('', true, 'get')
            },
        ];
        return getAsynch($q,calls);
    }

    function tmxRouter($stateProvider, $urlRouterProvider,$logProvider,routesProvider){
     
        $urlRouterProvider.otherwise("/public/login");
        var states=[
            new state("Private",true,true,['$q','lookupService','PrivateService','RoleManagementService',privateResolve]),
            new state("Frame",false,true),
            new state("Public",false,true),
            new state("Public.Frame",false,true),
            new state("Private.Dashboard",true,false,undefined),
            new state("Private.Inbox",true,false,['$q','LoanProductService','lookupService',inboxResolve]),
            new state("Private.Auditlog",true,false),
            new state("Private.Masterdata",false,true),
            new state("Private.Masterdata.Scheme",true),
            new state("Private.Transaction",false,true),
            new state("Private.Transaction.Order",true),
            new state("Private.Transaction.Payment",true),
            new state("Private.Transaction.BankDeposit",true),
            new state("Private.Transaction.Planogram",true),
            new state("Private.Transaction.Management",true),
            new state("Private.Administration",false,true),
            new state("Private.Journeyplans",false,true),
            new state("Private.Controls",false,true),
            new state("Private.Administration.ChangePassword",true),
            new state("Private.Administration.UploadData",true,false,["$stateParams","$injector",uploadDataResolve]),
            new state("Private.Reports",false,true),
            new state("Private.Reports.BusinessReports",true,false,["$q","RoleManagementService","lookupService","BranchService","TMX_FINANCE_CONSTANTS","LocationService","LoanProductService",businessReportsResolve]),
            new state("Private.Reports.BranchLevelReport",true,false,["$q","LoanApplicationService",branchLevelReportResolve]),
            new state("Private.Reports.AreaLevelReport",true,false,["$q","LoanApplicationService",areaLevelReportResolve]),
            new state("Private.Reports.RegionLevelReport",true,false,["$q","LoanApplicationService",regionLevelReportResolve]),
      // new state("Private.loanReport",true,false,['$q','LoanProductService','lookupService',inboxResolve]),
            new state("Private.Reports.TatSummaryReport",true,false,['$q','LoanProductService','lookupService',inboxResolve]),
            new state("Private.Reports.OperationReport",true,false,['$q','LoanProductService','lookupService',inboxResolve]),
            new state("Private.Reports.SessionHistoryReport",true,false,['$q','RoleManagementService',sessionHistoryReportResolve]),
            new state("Private.Reports.VisitReport",true,false,['$q','LoanProductService','lookupService',inboxResolve]),
            new state("Private.Reports.CallingReport",true,false,['$q','RoleManagementService','lookupService',callingReportResolve]),
            new state("Private.Reports.ApplicationStatusReport",true,false,['$q','LoanProductService',applicationStatusReportResolve]),
            new state("Private.Reports.OrganizationPortfolioReport",true,false,['$q','lookupService','TMX_FINANCE_CONSTANTS','OrganizationsService',SAReportsResolve]),
            new state("Private.Reports.CustomerPortfolioReport",true,false),
            new state("Private.Reports.AdvanceSummaryReport",true,false,['$q','lookupService','TMX_FINANCE_CONSTANTS','OrganizationsService',SAReportsResolve]),      
            new state("Private.Reports.DailyCreditReport",true),      
            new state("Private.Reports.CreditSummary",true,false,['$q','LoanProductService','lookupService',inboxResolve]),
            new state("Private.Reports.GuarantorSummary",true,false,['$q','LoanProductService','lookupService',inboxResolve]),
            new state("Private.geotracking", true, false, ['$q','UsersService','LocationService','DeviceService','lookupService','CompanyService','RoleManagementService',geoTrackingResolve]),
      //new state("Private.Reports.SalesByLocation",true),
      //new state("Private.ProfileLink",true),
            new state("Public.Login",true),
            new state("Public.forgotpassword",true),
            new state("Public.Register",true),
            new state("Public.home",false),
            new state("Public.Registerexternal",false,true),
            new state("Public.resetpassword",true),
            new state("Private.Masterdata.DynamicForm",true,false,["$q","TenantFieldSetupService","lookupService",'$stateParams','LoanApplicationService',dummyDynamicFormResolve]),
            new state("Private.Administration.RulesManagement", true, false,['$q','LoanProductService',"lookupService",ruleResolve])
            
        ];
        
        var crudStates=[
            new crudState("Private.Masterdata.Company",undefined,['$q','CompanyService',companyAddResolve],['$stateParams','$q','CompanyService',companyEditResolve],"",false),
            new crudState("Private.Masterdata.Organizations",['$q','OrganizationsService','LocationService','UsersService',organizationsListResolve],['$stateParams','$q','CustomersService','lookupService','LocationService','TMX_FINANCE_CONSTANTS','CompanyService',organizationsAddResolve],['$stateParams','$q','OrganizationsService','lookupService','LocationService','CustomersService','TMX_FINANCE_CONSTANTS','CompanyService',organizationsEditResolve],"",false),
            new crudState("Private.Masterdata.CompanyBranches",['$q','CompanyService','LocationService','UsersService',branchListResolve],['$q','BranchService','LocationService','CompanyService','LoanProductService','RoleManagementService','lookupService','TMX_FINANCE_CONSTANTS',branchAddResolve],['$stateParams','$q','BranchService','LocationService','CompanyService','LoanProductService','UsersService','RequestService','TMX_FINANCE_CONSTANTS','RoleManagementService','lookupService',branchEditResolve],"",false),
            new crudState("Private.Masterdata.Currency",undefined,undefined,['$stateParams','$q','CurrencyService',currencyEditResolve],"",false),      
      
            new crudState("Private.Administration.Users",['$q','UsersService', 'DeviceService', 'lookupService', usersListResolve],['$q','UsersService','LocationService','DeviceService','lookupService','CompanyService','RoleManagementService',usersAddResolve],['$stateParams','$q','UsersService','LocationService','DeviceService','RoleManagementService','RequestService','CompanyService','TMX_FINANCE_CONSTANTS',usersEditResolve],"",false),
            new crudState("Private.Masterdata.Customers",['$q','CustomersService', customersListResolve],['$q','CustomersService','OrganizationsService','lookupService','TMX_FINANCE_CONSTANTS',customersAddResolve],['$stateParams','$q','CustomersService','OrganizationsService','lookupService','TMX_FINANCE_CONSTANTS',customersEditResolve],"",false),
            new crudState("Private.Masterdata.UsersDynamic",['$q','UsersDynamicService', 'DeviceService', 'lookupService', usersDynamicListResolve],['$q','UsersDynamicService','LocationService','DeviceService','lookupService',usersDynamicAddResolve],['$stateParams','$q','UsersDynamicService','LocationService','DeviceService','lookupService',usersDynamicEditResolve],"",false),
            new crudState("Private.Masterdata.PriceList",['PriceListService',priceListListResolve],['PriceListService',priceListAddResolve],['$stateParams','PriceListService',priceListEditResolve],"",false),
            new crudState("Private.Masterdata.Supplier",['SupplierService',supplierListResolve],['SupplierService',supplierAddResolve],['$stateParams','SupplierService',supplierEditResolve],"",false),
            new crudState("Private.Masterdata.Warehouse",['WarehouseService',warehouseListResolve],['WarehouseService',warehouseAddResolve],['$stateParams','WarehouseService',warehouseEditResolve],"",false),
            new crudState("Private.Administration.RoleManagement",undefined,['$q','RoleManagementService',roleManagementAddResolve],['$stateParams',"$q",'RoleManagementService','RequestService','TMX_FINANCE_CONSTANTS',roleManagementEditResolve],"",false),
            new crudState("Private.Masterdata.Distributor",['DistributorService',distributorListResolve],['DistributorService',distributorAddResolve],['$stateParams','DistributorService',distributorEditResolve],"",false),
      // new crudState("Private.Masterdata.Customer",['CustomerService',customerListResolve],['CustomerService',customerAddResolve],['$stateParams','CustomerService',customerEditResolve],"",false),
            new crudState("Private.Masterdata.Location",undefined,['LocationService','$q',locationAddResolve],['$stateParams','LocationService',"$q",locationEditResolve],"",false),
            new crudState("Private.Masterdata.LookupManagement",['lookupService','$q',lookupListResolve],undefined,['$stateParams','$q','LookupManagementService','lookupService',lookupEditResolve],"",false),
            new crudState("Private.Masterdata.Product",['ProductService',productListResolve],['ProductService',productAddResolve],['$stateParams','ProductService','lookupService',productEditResolve],"",false),
            new crudState("Private.Administration.DeviceManagement",['$q','UsersService',deviceListResolve],['$q','DeviceService','lookupService','UsersService',deviceAddResolve],['$stateParams','$q','DeviceService','lookupService','UsersService',deviceEditResolve],"",false),
            new crudState("Private.Administration.DayEndManagement",['$q','DayendService',dayendListResolve],undefined,undefined,"",false),
            new crudState("Private.Administration.UserLimitManagement",['$q',userLimitListResolve],['$stateParams','$q','TMX_FINANCE_CONSTANTS','LoanProductService','UserLimitManagementService','lookupService','RoleManagementService','CompanyService','UsersService',userLimitAddResolve],['$stateParams','$q','TMX_FINANCE_CONSTANTS','LoanProductService','UserLimitManagementService','lookupService','RoleManagementService','CompanyService','UsersService',userLimitEditResolve],"",false),
           
            new crudState("Private.Administration.BulkReassignment",['$q','LoanProductService','BranchService',bulkReassignmentListResolve],undefined,undefined,"",false),
            new crudState("Private.Masterdata.BulkUpload",['$q','lookupService','LoanProductService','BulkUploadService','TMX_FINANCE_CONSTANTS',bulkUploadListResolve],undefined,undefined,"",false),
      
      //new crudState("Private.Administration.UserManagement",['UserService',userListResolve],['UserService',userAddResolve],['$stateParams','UserService',userEditResolve],"",false),
      //new crudState("Private.Administration.LookupManagement",['lookupService',LookupListResolve],['lookupService',LookupAddResolve],['$stateParams','lookupService',LookupEditResolve],"",false),
            new crudState("Private.ProfileLink",['CurrentUserService','$q','UsersService','LocationService','DeviceService','lookupService',profileLinkListResolve],undefined,['$stateParams','$q','UsersService','LocationService','DeviceService','lookupService',profileLinkEditResolve],"",false),
            new crudState("Private.Transaction.LoanApplication",['$q','LoanProductService','BranchService','lookupService','TMX_FINANCE_CONSTANTS',loanApplicationResolve],["$q","TenantFieldSetupService","lookupService",'$stateParams','LoanApplicationService','LoanProductService',DynamicFormAddResolve],["$q","TenantFieldSetupService","lookupService",'$stateParams','tmxResource','UsersService','LoanApplicationService','PrivateService','LocationService',DynamicFormResolve],"",true),
            new crudState("Private.Transaction.AccountOpeningApplication",['$q','LoanProductService','lookupService','BranchService','TMX_FINANCE_CONSTANTS',accountOpeningApplicationResolve],["$q","TenantFieldSetupService","lookupService",'$stateParams','LoanApplicationService','LoanProductService',DynamicFormAddResolve],["$q","TenantFieldSetupService","lookupService",'$stateParams','tmxResource','UsersService','LoanApplicationService',DynamicFormAccountResolve],"",true),
            new crudState("Private.Transaction.TradeRepository",['$q','LoanProductService','lookupService','TMX_FINANCE_CONSTANTS','BranchService',tradeRepositoryResolve],["$q","TenantFieldSetupService","lookupService",'$stateParams','LoanApplicationService','LoanProductService',DynamicFormAddResolve],["$q","TenantFieldSetupService","lookupService",'$stateParams','$state','tmxResource','UsersService','LoanApplicationService',DynamicFormTradeResolve],"",true),
            new crudState("Private.Transaction.LoanProduct",['LoanProductService',loanProductListResolve],['$q','LoanProductService',loanProductAddResolve],['$stateParams',"$q",'LoanProductService',loanProductEditResolve],"",false),
            new crudState("Private.Masterdata.GeoFence",['$q','LocationService',geoFenceListResolve],['$q','GeofenceService','LocationService',geoFenceAddResolve],['$stateParams','$q','GeofenceService','LocationService',geoFenceEditResolve],"",false),
            new crudState("Private.Journeyplans.Pjp",['$q','LocationService',pjpListResolve],['$q','PjpService','LocationService','GeofenceService','UsersService','lookupService',pjpAddResolve],['$stateParams','$q','PjpService','LocationService','GeofenceService','UsersService','lookupService',pjpEditResolve],"",false),
            new crudState("Private.Journeyplans.PjpSummary", ['$q','UsersService','PjpSummaryService', pjpSummaryResolve], undefined, undefined, "", false),
            new crudState("Private.Controls.ProcessDesigner",['$q','LocationService',geoFenceListResolve],undefined,undefined,"",false),
            new crudState("Private.Controls.ProcessInstances",['$q','ProcessInstancesService', processInstancesListResolve],['$q','ProcessInstancesService',processInstancesAddResolve],['$stateParams','$q','ProcessInstancesService',processInstancesEditResolve],"",false),
            new crudState("Private.Controls.ManagePrivileges",undefined,undefined,undefined,"",false),
            new crudState("Frame.LoanApplication",['$q','LoanProductService','BranchService','lookupService','TMX_FINANCE_CONSTANTS',loanApplicationResolve],["$q","TenantFieldSetupService","lookupService",'$stateParams','LoanApplicationService','LoanProductService',DynamicFormAddResolve],["$q","TenantFieldSetupService","lookupService",'$stateParams','tmxResource','UsersService','LoanApplicationService',DynamicFormResolve],"",false),
            new crudState("Private.Administration.RateUpload",undefined,undefined,undefined,"",false),
            new crudState("Private.Requests",undefined,undefined,['$q','$stateParams','RequestService', requstesEditResolve],"",false),
            new crudState("Private.Leads",undefined,undefined,['$q','$stateParams','LeadService','lookupService','TMX_FINANCE_CONSTANTS', leadsEditResolve],"",false),
            new crudState("Private.Transaction.Treasury", undefined, undefined, undefined, "", false),
            new crudState("Private.Transaction.LoanRepayment",['$q','LoanProductService','BranchService','lookupService','TMX_FINANCE_CONSTANTS',loanRepaymentListResolve],undefined,undefined,"",false)
        ];

        routesProvider.createRoutes(states);
        routesProvider.createCrudRoutes(crudStates);

        var test=routesProvider.returnObject.getRouteByName("Private");
        test.url="/home";
    // var test3=routesProvider.returnObject.getRouteByName("ProfileLink");
    // test3.url="/home";
        routesProvider.returnObject.getRouteByName("Public").url="/public";
        var test2=routesProvider.returnObject.getRouteByName("UploadData");
        test2.url+="/:Id";
        var dynamicFormDemo = routesProvider.returnObject.getRouteByName("DynamicForm");
        dynamicFormDemo.url+="/:Id";
        var loanApplicationEditRoute= routesProvider.returnObject.getRouteByState("private.transaction.loanapplication.edit");
        var loanApplicationAddRoute= routesProvider.returnObject.getRouteByState("private.transaction.loanapplication.add")
        loanApplicationEditRoute.url+="?callbackState";
        loanApplicationAddRoute.url+="/:Id?branchId&callbackState";
        var accountOpeningAppEditRoute= routesProvider.returnObject.getRouteByState("private.transaction.accountopeningapplication.edit");
        var accountOpeningAppAddRoute= routesProvider.returnObject.getRouteByState("private.transaction.accountopeningapplication.add")
        accountOpeningAppEditRoute.url+="?callbackState";
        accountOpeningAppAddRoute.url+="/:Id?branchId&callbackState";
        var tradeRepositoryEditRoute= routesProvider.returnObject.getRouteByState("private.transaction.traderepository.edit");
        var tradeRepositoryAddRoute= routesProvider.returnObject.getRouteByState("private.transaction.traderepository.add")
        tradeRepositoryEditRoute.url+="?callbackState";
        tradeRepositoryAddRoute.url+="/:Id?branchId&callbackState";
        var loanApplicationFrameEditRoute= routesProvider.returnObject.getRouteByState("frame.loanapplication.edit");
        var loanApplicationFrameAddRoute= routesProvider.returnObject.getRouteByState("frame.loanapplication.add")
        loanApplicationFrameEditRoute.url+="/:Screening?callbackState&readonly&joint&token&user";
        loanApplicationFrameAddRoute.url+="/:Id/:Screening?callbackState&readonly&joint&token&user";
    //loanApplicationAddRoute.url+="/:Id?callbackState";
        routesProvider.registerRoutes();
    }
})();
